/*
 * サブシステム名：ツール
 * 機能名：会計連携データ作成
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdTextBox from '@/components/DdTextBox'
import DdDropDown from '@/components/DdDropDown'
import DdCheckbox from '@/components/DdCheckbox'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'
// import date from '@/ddv2.library/date'
// import modals from '@/ddv2.library/modals'

export default {
  name: 'exportYayoiRenkeiData',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    rec: [],
    modeKengen: 0,
    page: 1,
    isLoading: false,

    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders
  }),
  components: {
    DdCustomButton,
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdTextBox,
    DdCodeTextBox,
    DdDateRangeBox,
    DdDropDown,
    DdCheckbox
  },
  watch: {
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.juchuYmdDisp = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        elem2.jissekiSagyoYmdDisp = elem.jissekiSagyoYmd ? filter.dateFormatter(elem.jissekiSagyoYmd) : ''
        elem2.sagyoYoteiYmdFromDisp = elem.sagyoYoteiYmdFrom ? filter.dateFormatter(elem.sagyoYoteiYmdFrom) : ''
        elem2.yayoiRenkeiFlgDisp = elem.yayoiRenkeiFlg ? '済' : '未'
        elem2.yayoiRenkeiYmdDisp = elem.yayoiRenkeiYmd ? filter.dateFormatter(elem.yayoiRenkeiYmd) : ''
        elem2.uriageKakuteiYmdDisp = elem.uriageKakuteiYmd ? filter.dateFormatter(elem.uriageKakuteiYmd) : ''
        elem2.seikyuKingakuSumDisp = filter.numericFormatter(elem.seikyuKingakuSum)
        elem2.isSelectable = true
        return elem2
      })
    },
    isKaikeiRenkeiButtonDisabled () {
      return this.rec.length === 0
    },
    isCreateButtonDisp () {
      return this.modeKengen >= 1
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      shubetsuList: 'DDMasters/mstShubetsu',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 担当者
    filteredUketsukeTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const jisha = this.torihikisakiList.filter(elem2 => elem2.torihikisakiBunruiKbn1 === '02')
        if (!jisha) {
          return false
        }
        return jisha.some(elem2 => elem2.torihikisakiCd === elem.shanaiBiko3) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('TGUTLD0011.defineHeaderPromise')
            self.headers = [
              { text: '', value: 'data-table-select' },
              { text: '弥生連携', value: 'yayoiRenkeiFlgDisp', align: 'center' },
              { text: '出力日', value: 'yayoiRenkeiYmdDisp', align: 'center' },
              { text: '出力者', value: 'yayoiRenkeiJisshishaNm', align: 'center' },
              { text: '客先注文番号', value: 'chumonNo' },
              // { text: '受付日', value: 'juchuYmdDisp', align: 'center' },
              { text: '作業日', value: 'jissekiSagyoYmdDisp', align: 'center' },
              { text: '得意先', value: 'seikyusakiNm' },
              { text: '取付先', value: 'toritsukesaki' },
              { text: '営業所', value: 'eigyosho' },
              // { text: '売上確定', value: 'uriageKakuteiFlgString', align: 'center' },
              { text: '売上確定日', value: 'uriageKakuteiYmdDisp', align: 'center' },
              { text: '売上確定担当者', value: 'uriageKakuteiTantoshaNm' },
              { text: 'ジャンル', value: 'genreSbtNm' },
              { text: '作業区分', value: 'sagyoKbnNm' },
              { text: '商品', value: 'shohinNm' },
              { text: '車番プレートNo', value: 'newShabanPlateNo' },
              { text: '作業／部材', value: 'sagyoOptionNm' },
              { text: '数量', value: 'juchuSuryo', align: 'end' },
              { text: '請求金額', value: 'seikyuKingakuSumDisp', align: 'end' },
              { text: '自社管理番号', value: 'jishaDenpyoNo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              juchuStartYmd: null,
              juchuEndYmd: null,
              seikyusakiId: null,
              chumonNo: null,
              uriageKakuteiTantoshaId: null,
              notYayoiRenkeiFlg: true
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('TGUTLD0011.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
          }
          console.log('TGUTLD0011.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('TGUTLD0011.researchPromise', c)
          return new Promise(resolve => {
            self.isLoading = true
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('TGUTLD0011.restoreViewPromise', c)
          return new Promise(resolve => {
            self.isLoading = true
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            self.$nextTick(() => { self.isLoading = false })
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.rec = []
      this.rows = []

      console.log('★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★')
      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.isLoading = true

          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCTgutld0011/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          self.isLoading = false
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            // const d = new Date()
            this.conditions = {
              juchuStartYmd: null,
              juchuEndYmd: null,
              seikyusakiId: null,
              chumonNo: null,
              uriageKakuteiTantoshaId: null,
              notYayoiRenkeiFlg: true
            }
            this.searchText = ''
            this.rows = []
            this.rec = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log(this.rows)
      this.Effects.loadStart()
      this.clear()
    },
    onKaikeiRenkeiButtonClick: function (issueFlg) {
      this.Effects.loadStart()
      const idList = this.rec.map(elem => elem.trSagyoMeisaiId)
      this.HttpClient
        .requestFileByPost(`/api/v1/vwCTGUTLD0011/ExcelOutput?issueFlg=${issueFlg}`, { trSagyoMeisaiIdList: idList })
        .then((data) => {
          this.Effects.loadComplete()
          this.clearSummaryMessage()
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.ms-excel.sheet.macroEnabled.12' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '弥生連携データ' + (issueFlg ? '_' : '(仮)_') + ts + '.xlsm'
          elem.click()

          this.rec = []
          this.onSearchButtonClick()
        })
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 受付日FROM TOの大小チェック
      var msg = validators.compareDate(this.conditions.juchuStartYmd, this.conditions.juchuEndYmd)
      if (msg !== undefined) {
        this.$refs.juchuStartYmd[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.juchuEndYmd[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }

      return true
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    }
  }
}
